import { render } from "./channelUser.vue?vue&type=template&id=2ef25138"
import script from "./channelUser.vue?vue&type=script&lang=js"
export * from "./channelUser.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/channel/channelUser.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ef25138"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ef25138', __exports__)) {
    console.log('reload')
    api.reload('2ef25138', __exports__)
  }
  
  module.hot.accept("./channelUser.vue?vue&type=template&id=2ef25138", () => {
    console.log('re-render')
    api.rerender('2ef25138', render)
  })

}


export default __exports__